import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a passenger car not available icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <PassengerCarNotAvailableIcon width={24} />
 */
const PassengerCarNotAvailableIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M7.849 4.02988C7.89793 4.01511 7.94816 4.00507 7.999 3.99988H15.999C16.2906 4.01454
            16.5726 4.10903 16.8142 4.27303C17.0558 4.43704 17.2477 4.66425 17.369 4.92988L18.629
            8.06988C18.8922 8.6731 19.2568 9.22677 19.707 9.70688L20.297 10.2969C20.716 10.768 20.9627
            11.3673 20.997 11.9969V17.1669L18.797 14.9669C19.0625 14.9126 19.3083 14.7875 19.5083
            14.6047C19.7084 14.4219 19.8552 14.1884 19.9332 13.9289C20.0111 13.6694 20.0174 13.3936
            19.9512 13.1309C19.885 12.8681 19.7489 12.6282 19.5573 12.4366C19.3657 12.245 19.1258 12.1089
            18.863 12.0427C18.6003 11.9765 18.3245 11.9827 18.065 12.0607C17.8055 12.1387 17.5719 12.2855
            17.3892 12.4855C17.2064 12.6856 17.0813 12.9314 17.027 13.1969L13.827 9.99688H17.497C17.5544
            10.0063 17.6134 9.9989 17.6667 9.97544C17.72 9.95198 17.7653 9.91352 17.7971 9.86476C17.8289
            9.81599 17.8458 9.75903 17.8458 9.70081C17.8458 9.64259 17.8288 9.58563 17.797 9.53688L16.197
            5.95688C16.1304 5.82592 16.0309 5.71459 15.9081 5.63392C15.7853 5.55324 15.6436 5.506 15.497
            5.49688H9.329L7.849 4.02988ZM21.207 21.7069C21.0174 21.8928 20.7625 21.9969 20.497 21.9969C20.2315
            21.9969 19.9766 21.8928 19.787 21.7069L16.087 17.9969H6V18.9969C6 19.2621 5.89465 19.5165 5.70711
            19.704C5.51957 19.8915 5.26522 19.9969 5 19.9969H4C3.73479 19.9969 3.48043 19.8915 3.2929
            19.704C3.10536 19.5165 3 19.2621 3 18.9969V11.9969C3.03512 11.3627 3.28559 10.7594 3.71 10.2869L4.3
            9.69688C4.75005 9.21514 5.11522 8.66062 5.38 8.05688L5.6 7.50688L2.799 4.70688C2.64019 4.51509
            2.55864 4.27095 2.57031 4.02222C2.58198 3.77349 2.68603 3.53806 2.86211 3.36199C3.03818 3.18591
            3.27361 3.08186 3.52234 3.07019C3.77108 3.05852 4.01522 3.14007 4.207 3.29888L21.207 20.2989C21.3926
            20.4862 21.4968 20.7392 21.4968 21.0029C21.4968 21.2666 21.3926 21.5196 21.207 21.7069ZM6.639
            8.55988L6.199 9.53988C6.16718 9.58863 6.15022 9.64559 6.15021 9.70381C6.1502 9.76203 6.16713 9.81899
            6.19893 9.86776C6.23073 9.91652 6.27604 9.95498 6.32932 9.97844C6.3826 10.0019 6.44156 10.0093
            6.499 9.99988H8.089L6.639 8.55988ZM6.999 13.4999C6.999 13.2032 6.91103 12.9132 6.74621 12.6665C6.58139
            12.4199 6.34712 12.2276 6.07303 12.1141C5.79894 12.0005 5.49734 11.9708 5.20637 12.0287C4.9154 12.0866
            4.64812 12.2294 4.43834 12.4392C4.22856 12.649 4.0857 12.9163 4.02782 13.2072C3.96995 13.4982 3.99965
            13.7998 4.11318 14.0739C4.22672 14.348 4.41897 14.5823 4.66565 14.7471C4.91232 14.9119 5.20233 14.9999
            5.499 14.9999C5.89683 14.9999 6.27836 14.8418 6.55966 14.5605C6.84097 14.2792 6.999 13.8977 6.999
            13.4999ZM14.089 15.9999L13.089 14.9999H9.999C9.73379 14.9999 9.47943 15.1052 9.2919 15.2928C9.10436
            15.4803 8.999 15.7347 8.999 15.9999H14.089Z`}
        />
    </SvgIcon>
)

PassengerCarNotAvailableIcon.defaultProps = defaultProps

export { PassengerCarNotAvailableIcon }
